








import BaseComponent from "@/asdcom/BaseComponent";
import { Prop, Component, Watch, Emit } from "vue-property-decorator";
import { IHeader } from "@/store/models/staff/IHeader";
import { IApplicantRequestTaskDto } from "@/asdcom/apiproxy/apiproxy.dto";
import MasterDetailsComponent from "@/components/vcponlineok/staff-user/master-details-component.vue";

interface ITableRow {
  itemId: number;
  receivedDate: string;
  requestType?:number;
  requestTypeName: string;
  applicantName: string;
  applicantUsername: string;
  applicantEmail: string;
}

@Component({components:{MasterDetailsComponent}})
export default class ApplicantRequestListComponent extends BaseComponent {
  @Prop({
    default: () => {
      return null;
    }
  })
  viewModel?: IApplicantRequestTaskDto[];

  headers: IHeader[] = [
    { text: "Received Date", value: "receivedDate", align: "center" },
    { text: "Request Type", value: "requestTypeName", align: "center" },
    { text: "Applicant Name", value: "applicantName", align: "center" },
    { text: "Applicant Email", value: "applicantEmail", align: "center" }
  ];
  tableData: ITableRow[] = [];

  get getTableData() {
    this.tableData = [];
    if (this.viewModel !== undefined && this.viewModel.length > 0) {
      for (let item in this.viewModel) {
        let row = {} as ITableRow;
        row.itemId = this.viewModel[item].itemId as number;
        row.receivedDate = this.getDate(this.viewModel[item].receivedDate);
        row.requestType = this.viewModel[item].requestType;
        row.requestTypeName = this.L(this.getConstName(
          "userSubmissionType",
          this.viewModel[item].requestType
        ) as string) as string;
        row.applicantName =
          this.viewModel[item].applicantFirstName +
          " " +
          this.viewModel[item].applicantLastName;
        row.applicantUsername = this.viewModel[item]
          .applicantUserName as string;
        // row.contact = [];
        // let phoneNumber = this.listData[item].applicantPhone as string + " ";
        row.applicantEmail = this.viewModel[item].applicantEmail as string;
        // row.contact.push(phoneNumber, email)
        this.tableData.push(row);
      }
      return this.tableData;
    } else {
      return this.tableData;
    };
      abp.log.debug({"applicant-request-list-component getTableData": this.viewModel});
  }

}
